import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./PspLinkCard.scss";
import { H3, Paragraph } from "components/core/Typography";
import { Image } from "@sparefoot/react-commons";

/**
 * PspLinkCard component for displaying storage type information
 * @param {Object} props - Component props
 * @param {string} props.image - Image URL
 * @param {string} props.title - Card title
 * @param {string} props.description - Card description
 * @param {string} props.link - Link URL for the card
 * @returns {JSX.Element} PspLinkCard component
 */
export default function PspLinkCard({ image, title, description, link }) {
	return (
		<Link
			to={link}
			className="psp-link-card"
		>
			<div className="psp-link-card-content">
				<div className="psp-link-card-wrapper">
					<div className="psp-link-card-inner">
						<div className="psp-link-card-image">
							<Image
								alt={title}
								src={image}
							/>
						</div>
						<div className="psp-link-card-copy">
							<H3
								className="psp-link-card-title"
								weight="bold"
								size="standard"
							>
								{title}
							</H3>
							<Paragraph className="psp-link-card-description">
								{description}
							</Paragraph>
						</div>
					</div>
				</div>
			</div>
		</Link>
	);
}

PspLinkCard.propTypes = {
	image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	link: PropTypes.string.isRequired
};
